import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Starfield from "@/components/Starfield";
import QuizEngine from "@/components/QuizEngine";
import TieBreak from "@/components/TieBreak";
import { EMOTIONAL_DECODER } from "@/data/decoder";
import {
    tallyScores,
    primaryMatches,
    resolveOutcome,
    resolvePatternByKey,
} from "@/lib/scoring";
import { track, EVENTS } from "@/lib/analytics";

export default function Quiz() {
    const navigate = useNavigate();
    const [tied, setTied] = useState(null);

    useEffect(() => {
        document.title = "The decoder | WHY THE FUCK DO I DO THAT?";
        track(EVENTS.DECODER_STARTED, {
            decoder: EMOTIONAL_DECODER.id,
            questions: EMOTIONAL_DECODER.questions.length,
        });
    }, []);

    const complete = (pattern) => {
        track(EVENTS.DECODER_COMPLETED, {
            decoder: EMOTIONAL_DECODER.id,
            pattern: pattern.key,
        });
        navigate(`/r/${pattern.slug}`, { replace: true });
    };

    const onComplete = (answers) => {
        const scores = tallyScores(EMOTIONAL_DECODER, answers);
        const primaries = primaryMatches(EMOTIONAL_DECODER, answers);
        const outcome = resolveOutcome(EMOTIONAL_DECODER, scores, primaries);
        if (outcome.type === "pattern") {
            complete(outcome.pattern);
        } else {
            setTied(outcome.tied);
        }
    };

    const onTieResolve = (key) => {
        complete(resolvePatternByKey(EMOTIONAL_DECODER, key));
    };

    return (
        <main className="relative min-h-dvh overflow-hidden bg-ink text-slate-200">
            <Starfield density={45} />
            <div className="relative z-10 mx-auto flex min-h-dvh w-full max-w-xl flex-col px-5 pb-10 pt-2">
                {tied ? (
                    <TieBreak
                        tieBreak={EMOTIONAL_DECODER.tieBreak}
                        tied={tied}
                        onResolve={onTieResolve}
                    />
                ) : (
                    <QuizEngine
                        decoder={EMOTIONAL_DECODER}
                        onComplete={onComplete}
                    />
                )}
            </div>
        </main>
    );
}
